import React from 'react';
import { ProfileRebindWidget } from './widget';

export const ProfileRebindPage: React.FC = () => <ProfileRebindWidget />;
